import { gql } from '@apollo/client';

export const GET_QUOTE_BY_CLINIC_ID = gql`
  query getQuoteByClinicId($clinicId: String, $endOfValidity: String) {
    getQuoteByClinicId(clinicId: $clinicId, endOfValidity: $endOfValidity) {
      id
      status
      summary
      statementUrl
      invoiceUrl
      invoiceKey
      country
    }
  }
`;
export const GET_SOA_ENABLED_CLINICS = gql`
  query {
    getSOAEnabledClinics {
      value: id
      label: name
      country
    }
  }
`;

export const GET_QUOTE_LINES_BY_QUOTE_ID = gql`
  query getQuoteLinesByQuoteId($quoteId: String, $filter: GetQuoteLineFilter) {
    getQuoteLinesByQuoteId(quoteId: $quoteId, filter: $filter) {
      edges {
        id
        quoteId
        patientId
        doctorId
        type
        eventDate
        commission
        deletedAt
        updatedAt
        data {
          eventId
          eventType
          alignerCount
          productType
        }
        patient {
          id
          email
          phone
          lastName
          firstName
        }
        doctor {
          id
          lastName
          firstName
        }
        quoteLineHistory {
          id
          action
          updatedAt
          updatedBy
          isOriginalRecord
          updatedValue {
            commission
            type
            eventDate
            doctor {
              lastName
              firstName
            }
            patient {
              id
              email
              phone
              lastName
              firstName
            }
            data {
              comments
              eventType
              productType
              alignerCount
            }
            deletedAt
          }
        }
      }
      hasNext
    }
  }
`;

export const UPDATE_QUOTE = gql`
  mutation updateQuote($id: String, $input: UpdateQuoteObjectInput) {
    updateQuote(id: $id, input: $input) {
      id
    }
  }
`;
export const REVERT_QUOTE = gql`
  mutation revertQuote($id: String) {
    revertQuote(id: $id) {
      id
    }
  }
`;

export const UPDATE_QUOTE_LINE = gql`
  mutation ($input: QuoteLineProposalInput) {
    createQuoteLineProposal(input: $input) {
      id
      quoteId
    }
  }
`;

export const FINANCE_FILE_UPLOAD = gql`
  mutation getInvoiceUploadUrl($id: String, $name: String) {
    getInvoiceUploadUrl(id: $id, name: $name) {
      presignedUrl
      key
    }
  }
`;

export const GET_QUOTE_LINE_PROPOSAL_FIELD = gql`
  query getQuoteLineProposalFields($input: GetQuoteLineProposalFieldsInput) {
    getQuoteLineProposalFields(input: $input) {
      productType
      commission
      alignerCount
    }
  }
`;

export const GET_QUOTES_BY_STATUS = gql`
  query getQuotesByStatus(
    $status: QuoteStatus!
    $paginationInfo: PaginationInfo
  ) {
    getQuotesByStatus(status: $status, paginationInfo: $paginationInfo) {
      edges {
        id
        endOfValidity
        clinic {
          name
          id
          country
        }
      }
      hasNext
    }
  }
`;

export const GET_ACCOUNT_STATEMENT_COUNT = gql`
  query getAccountStatementCount {
    getAccountStatementCount {
      status
      count
    }
  }
`;
